/**
 * Convierte una fecha de input (YYYY-MM-DD) a formato ISO para la API
 * SIN aplicar conversiones de zona horaria - trabaja SOLO con strings
 * @param {string} dateString - Fecha en formato YYYY-MM-DD del input
 * @param {string} time - Hora en formato HH:MM:SS (opcional, por defecto 09:00:00)
 * @returns {string} - Fecha en formato ISO: YYYY-MM-DDTHH:MM:SS
 */
export const formatDateForAPI = (dateString, time = '09:00:00') => {
  if (!dateString) return '';
  
  // IMPORTANTE: NO usar new Date() - solo concatenar strings
  // El input date devuelve "2024-01-15" y lo enviamos como "2024-01-15T09:00:00"
  const result = `${dateString}T${time}`;
  
  // Log para debugging - remover después de confirmar que funciona
  console.log(`📆 formatDateForAPI: "${dateString}" → "${result}"`);
  
  return result;
};

/**
 * Extrae la parte de fecha (YYYY-MM-DD) de un string ISO del backend
 * SIN aplicar conversiones de zona horaria - trabaja SOLO con strings
 * @param {string} isoString - Fecha en formato ISO del backend (ej: "2024-01-15T09:00:00")
 * @returns {string} - Fecha en formato YYYY-MM-DD
 */
export const formatDateForInput = (isoString) => {
  if (!isoString) return '';
  
  // IMPORTANTE: NO usar new Date() - solo extraer substring
  // "2024-01-15T09:00:00" -> "2024-01-15"
  return isoString.split('T')[0];
};

/**
 * Valida que la fecha de fin sea posterior a la fecha de inicio
 * Compara strings directamente sin conversiones de zona horaria
 * @param {string} startDate - Fecha de inicio en formato YYYY-MM-DD
 * @param {string} endDate - Fecha de fin en formato YYYY-MM-DD
 * @returns {boolean} - true si la fecha de fin es posterior o igual
 */
export const isEndDateAfterStartDate = (startDate, endDate) => {
  if (!startDate || !endDate) return true;
  
  // IMPORTANTE: Comparación directa de strings (funciona con formato YYYY-MM-DD)
  // "2024-01-15" > "2024-01-14" = true
  return endDate >= startDate;
};

/**
 * Obtiene la fecha actual en formato YYYY-MM-DD
 * SOLO para usar en funciones auxiliares (getTodayDateString, getMaxDateString)
 * NO usar para convertir fechas del usuario
 * @returns {string} - Fecha actual
 */
export const getTodayDateString = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Obtiene una fecha máxima (años en el futuro) en formato YYYY-MM-DD
 * SOLO para usar como límite en inputs date
 * NO usar para convertir fechas del usuario
 * @param {number} yearsAhead - Años hacia adelante (por defecto 10)
 * @returns {string} - Fecha máxima
 */
export const getMaxDateString = (yearsAhead = 10) => {
  const today = new Date();
  const year = today.getFullYear() + yearsAhead;
  const month = '12';
  const day = '31';
  return `${year}-${month}-${day}`;
};

